import { cn } from '../../../utils/string/cn.utils';
import './Chip.scss';

const Chip = ({ label, active, posIcon, ...props }) => {
  return (
    <div
      {...props}
      className={cn('chip ', active ? 'active ' : '', props?.className)}
    >
      {posIcon}
      {label}
    </div>
  );
};

export default Chip;
